import styled from "styled-components";

export const MainStyles = styled.div`
  .btn-group {
    background-color: #ffffff;
  }
`;

export const HeaderWrapper = styled.div`
  .group-header {
    background-color: #fff;
    padding: 16px;
    position: relative;
    z-index: 100;
    display: flex;
    justify-content: flex-end;
  }
`;

export const Styles = styled.div`
  .btn-create {
    > svg {
      transform: rotate(135deg);
    }
  }
  .border-top {
    border-top: 2px solid #bcbcbc;
    padding-top: 12px;
  }
  .group-btn {
    display: flex;
    flex-direction: row;
    gap: 12px;

    &:last-child {
      padding-top: 10px;
    }

    button {
      min-width: 100px;
      background: #456e9b;
      border-radius: 8px;
      padding: 10px 16px;
      background: #174a83;

      &.btn-add {
        width: 100px;
        max-width: 100px;
      }
    }
  }

  button {
    &.btn-add {
      width: 150px;
      max-width: 150px;
      min-width: unset;
    }
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .group-btn {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
    padding-top: 10px;

    button {
      background: #456e9b;
      padding: 10px 6px;
      background: #174a83;
      min-width: 150px;
      border-radius: 8px;
    }

    .btn-back {
      background: #ffffff;
      border: 1px solid #174a83;
      color: #174a83;
      min-width: 120px;
    }
  }
`;
